'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (ColourBlockParallax, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.ColourBlockParallax = $('[data-colour-block-parallax]');
    };

    var ColourBlockParallaxInit = function ColourBlockParallaxInit() {
      var offset = 350;
      var ColourBlockParallax = function ColourBlockParallax(current) {
        var colourOffset = current.parent().offset().top - offset;
        var speed = 10;
        if (current.attr('data-parallax-speed') != undefined) {
          var speed = current.attr('data-parallax-speed');
        }

        if ($(window).scrollTop() > colourOffset && $(window).scrollTop() < colourOffset + $(window).height()) {
          var topPosition = ($(window).scrollTop() - colourOffset) / speed;
          if (topPosition < 0) {
            topPosition = 0;
          }
          if (current.attr('data-parallax-direction') == 'up') {
            current.css('margin-bottom', topPosition);
          } else {
            current.css('margin-bottom', topPosition * -1);
          }
        }
      };
      $dom.ColourBlockParallax.each(function () {
        ColourBlockParallax($(this));
      });
      $(window).on('scroll', function () {
        $dom.ColourBlockParallax.each(function () {
          ColourBlockParallax($(this));
        });
      });
    };

    ColourBlockParallax.init = function () {
      cacheDom();
      ColourBlockParallaxInit();
    };
  })(window.ColourBlockParallax = window.ColourBlockParallax || {}, _jquery2.default, undefined);
};